import { gql } from "@apollo/client";

export const BUILDING_UTILITIES_FIELDS_FRAGMENT = gql`
  fragment BuildingUtilitiesFieldsV2 on BuildingInterface {
    id
    slug
    includedUtilities
    utilitiesIncluded
    __typename
  }
`;

export default BUILDING_UTILITIES_FIELDS_FRAGMENT;
